/**
 * @file Generate redirect paths after resetting and submitting the compose form
 */

import { useLocation } from 'react-router-dom';

import useComposeType from '../../../hooks/router/search/useComposeType';
import useIsMobile from '../../../hooks/useIsMobile';
import {
  getCloseComposeUrl,
  getOpenComposeUrl,
} from '../../../routes/urls/searchParams/compose';
import { ComposeNodeId } from '../props';

type RedirectUrls = [string | null, string | null];

/**
 * Generate redirect paths after resetting and submitting the compose form
 *
 * @param nodeId The ID of the node the compose is for
 *
 * @returns      The array of 2 redirect paths: [cancelUrl, submitUrl]
 */
const useRedirectPaths = (nodeId: ComposeNodeId): RedirectUrls => {
  const composeType = useComposeType();
  const isMobile = useIsMobile();
  const location = useLocation();

  const closeComposeUrl = getCloseComposeUrl(location);
  const openComposeUrl = getOpenComposeUrl(location, composeType);

  const cancelUrl = isMobile ? closeComposeUrl : openComposeUrl;

  if (nodeId !== null) {
    return [cancelUrl, closeComposeUrl].map(url =>
      url.replace('/' + nodeId, ''),
    ) as RedirectUrls;
  }

  return [null, closeComposeUrl];
};

export default useRedirectPaths;
